export enum ToolVisibilityType {
  Private = 'private',
  Team = 'team',
  Public = 'public',
}
